module.exports = __webpack_public_path__ + "static/media/arrow-product.e3ac2ce6.svg";